export enum customerOrderStatus {
  New = 'New',
  Confirmed = 'Confirmed',
  Invoiced = 'Invoiced',
  Cancelled = 'Cancelled',
  ToInvoice = 'ToInvoice',
  PendingApproval = 'PendingApproval',
  Quote = 'Quote',
  QuoteRequest = 'QuoteRequest',
  Ready = 'Ready',
  Complete = 'Complete',
  DepartmentConfirmed = 'DepartmentConfirmed',
}
